import { createReducer, on } from '@ngrx/store';
import { AuthActions } from '../_actions/auth.actions';
import { UserModel } from '../../_models/user.model';
import { SalesmanActions } from '../_actions/salesman.actions';
import { SaleModel } from '../../_models/sale.model';
import { PrizeRequestModel } from '../../_models/prize-request.model';

export interface SalesmenState {
  list: {
    filters: any;
    data: ReadonlyArray<UserModel>;
    total: number;
  };
  selected: UserModel | null;

  // Saldo de puntos actual
  currentPoints: number | null;
  pointsLoading: boolean;
  pointsError: any;

  // Ventas del vendedor
  vehicles: {
    filters: any;
    data: ReadonlyArray<SaleModel>;
    total: number;
    loading: boolean;
    error: any;
  };

  // Canjes del vendedor
  prizeRequests: {
    filters: any;
    data: ReadonlyArray<PrizeRequestModel>;
    total: number;
    loading: boolean;
    error: any;
  };

  // Estados de exportación
  exportingVehicles: boolean;
  exportingPrizeRequests: boolean;
}

export const initialStateSalesman: SalesmenState = {
  list: {
    filters: {},
    data: [],
    total: 0,
  },
  selected: null,
  currentPoints: null,
  pointsLoading: false,
  pointsError: null,
  vehicles: {
    filters: {},
    data: [],
    total: 0,
    loading: false,
    error: null,
  },
  prizeRequests: {
    filters: {},
    data: [],
    total: 0,
    loading: false,
    error: null,
  },
  exportingVehicles: false,
  exportingPrizeRequests: false,
};

export const salesmenFeatureKey = 'salesmen';

export const salesmenReducer = createReducer(
  initialStateSalesman,

  // Cargar lista de vendedores
  on(SalesmanActions.loadSalesmen, (state, { filters }) => ({
    ...state,
    list: {
      ...state.list,
      filters,
    },
  })),

  on(SalesmanActions.loadSalesmenSuccess, (state, { items, total }) => ({
    ...state,
    list: {
      ...state.list,
      data: items,
      total: total,
    },
  })),

  // Cargar vendedor individual
  on(SalesmanActions.loadSalesman, (state) => ({
    ...state,
    selected: null,
  })),

  on(SalesmanActions.loadSalesmanSuccess, (state, { data }) => ({
    ...state,
    selected: data,
  })),

  on(SalesmanActions.loadSalesmanFailure, (state, { error }) => ({
    ...state,
    selected: null,
  })),

  // Cargar puntos
  on(SalesmanActions.loadCurrentPoints, (state) => ({
    ...state,
    pointsLoading: true,
    pointsError: null,
  })),

  on(SalesmanActions.loadCurrentPointsSuccess, (state, { points }) => ({
    ...state,
    currentPoints: points,
    pointsLoading: false,
    pointsError: null,
  })),

  on(SalesmanActions.loadCurrentPointsFailure, (state, { error }) => ({
    ...state,
    currentPoints: null,
    pointsLoading: false,
    pointsError: error,
  })),

  // Cargar ventas
  on(SalesmanActions.loadVehicles, (state, { filters }) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      filters,
      loading: true,
      error: null,
    },
  })),

  on(SalesmanActions.loadVehiclesSuccess, (state, { vehicles, total }) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      data: vehicles,
      total,
      loading: false,
    },
  })),

  on(SalesmanActions.loadVehiclesFailure, (state, { error }) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      loading: false,
      error,
    },
  })),

  // Exportar ventas
  on(SalesmanActions.exportVehicles, (state) => ({
    ...state,
    exportingVehicles: true,
  })),

  on(SalesmanActions.exportVehiclesSuccess, (state) => ({
    ...state,
    exportingVehicles: false,
  })),

  on(SalesmanActions.exportVehiclesFailure, (state) => ({
    ...state,
    exportingVehicles: false,
  })),

  // Cargar canjes
  on(SalesmanActions.loadPrizeRequests, (state, { filters }) => ({
    ...state,
    prizeRequests: {
      ...state.prizeRequests,
      filters,
      loading: true,
      error: null,
    },
  })),

  on(SalesmanActions.loadPrizeRequestsSuccess, (state, { prizeRequests, total }) => ({
    ...state,
    prizeRequests: {
      ...state.prizeRequests,
      data: prizeRequests,
      total,
      loading: false,
    },
  })),

  on(SalesmanActions.loadPrizeRequestsFailure, (state, { error }) => ({
    ...state,
    prizeRequests: {
      ...state.prizeRequests,
      loading: false,
      error,
    },
  })),

  // Exportar canjes
  on(SalesmanActions.exportPrizeRequests, (state) => ({
    ...state,
    exportingPrizeRequests: true,
  })),

  on(SalesmanActions.exportPrizeRequestsSuccess, (state) => ({
    ...state,
    exportingPrizeRequests: false,
  })),

  on(SalesmanActions.exportPrizeRequestsFailure, (state) => ({
    ...state,
    exportingPrizeRequests: false,
  }))
);
